// Экземпляр i18next. Инициализирует его src/i18n/runtime.ts (initI18n) ДО загрузки кода
// приложения (main.tsx): язык и каталоги известны раньше, чем вычисляется любой модуль.
// Функция перевода для кода — `import { t } from '@/i18n'`.
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next)

export default i18n
